import { __decorate, __metadata, __param } from "tslib";
import _ from 'lodash';
import { inject, injectable } from 'inversify';
import { BehaviorSubject } from 'rxjs';
import { NO_REDIRECT } from '../@core/environment';
import { Symbols } from '../symbols';
import { sleep } from '@/@core/utils/task';
let SystemService = class SystemService {
    constructor(environment, uniSetting) {
        this.environment = environment;
        this.uniSetting = uniSetting;
        this._init = false;
        this._region = '';
        this.region$ = new BehaviorSubject(null);
        this.Region = environment.region;
    }
    get Debug() {
        return this.environment.debug || this.environment.development;
    }
    get Verbose() {
        return this.environment.verbose;
    }
    get Init() {
        return this._init;
    }
    set Init(value) {
        this._init = value;
    }
    get Region() {
        return this._region;
    }
    set Region(value) {
        if (this._region !== value) {
            this.region$.next(value);
        }
        this._region = value;
    }
    get IsCn() {
        return _.upperCase(this.Region) === 'CN';
    }
    get Permission() {
        return this.environment.permission || this.Debug;
    }
    async redirectTo(url) {
        console.log('Begin Redirect To', url);
        if (NO_REDIRECT) {
            return;
        }
        window.location.href = url;
        await sleep(6000);
    }
    reportError(...err) {
        if (this.Debug) {
            console.log(console, err);
        }
    }
    reportVerboseError(...err) {
        if (this.Verbose) {
            console.error(console, err);
        }
    }
    reportSystemInfo() {
        console.table([{
                key: 'Init',
                value: this.Init,
            }, {
                key: 'Region',
                value: this.Region,
            }, {
                key: 'Debug',
                value: this.Debug,
            }, {
                key: 'Verbose',
                value: this.Verbose,
            }, {
                key: 'Environment',
                value: JSON.stringify(this.environment, null, 4),
            }, {
                key: 'UniSetting',
                value: this.uniSetting,
            }]);
    }
};
SystemService = __decorate([
    injectable(),
    __param(0, inject(Symbols.Environment)),
    __param(1, inject(Symbols.UniSetting)),
    __metadata("design:paramtypes", [Object, Object])
], SystemService);
export { SystemService };
